var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgLearnAbel = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 17.292,
      viewBox: "0 0 18 17.292",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_20059",
      "data-name": "Path 20059",
      d: "M7009.4,2672.111l-2.022,11.17a.677.677,0,0,1-.665.554h-8.874a1.1,1.1,0,0,0-1.1,1.071.945.945,0,0,0,.917.973h.025l10.426.048a.605.605,0,0,0,.6-.5l1.958-11.56a.228.228,0,0,1,.449-.031l.455,1.464a.837.837,0,0,1,.027.379l-1.857,11.421a.834.834,0,0,1-.824.7h-13.165a2.141,2.141,0,0,1-2.1-2.573l2.52-12.279a3.055,3.055,0,0,1,2.993-2.441h10.186a.3.3,0,0,1,.3.3.319.319,0,0,1-.005.057Z",
      transform: "translate(-6993.602 -2670.504)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgLearnAbel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Learn_ABEL.2492ce00.svg";
export { ForwardRef as ReactComponent };